import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {User} from "../../../../shared/interface/user";
import {of, ReplaySubject} from "rxjs";
import {Employee, LeaveOfAbsence} from "../../../../shared/interface/employee";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  DictService
} from "../../../../shared/services/dict.service";
import {PartnerService} from "../../../../shared/services/partner.service";
import {OfwcaService} from "../../../../shared/services/ofwca.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {EmployeeService} from "../../../../shared/services/employee.service";

@Component({
  selector: 'app-employee-details-form',
  templateUrl: './employee-details-form.component.html',
  styleUrls: ['./employee-details-form.component.scss']
})
export class EmployeeDetailsFormComponent implements OnInit, OnDestroy {
  @Input() user: User;
  @Input() employee: ReplaySubject<Employee>;
  @Output() closeModification = new EventEmitter<any>();

  formErrors = {};
  employeeObject?: Employee = null;
  employeeForm: FormGroup;
  employmentAtControl: FormControl;
  employmentToControl: FormControl;
  workingHoursControl: FormControl;
  currentLeave: LeaveOfAbsence;
  dayToUseControl: FormControl;
  currentLeaveControl: FormControl;
  overdueLeaveControl: FormControl;
  childcareLeaveToUseControl: FormControl;
  receptionDayToUseControl: FormControl;

  userPermissions: ReplaySubject<UserPermissions>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private employeeService: EmployeeService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.employeeForm = fb.group({
      employmentAt: this.employmentAtControl = fb.control(''),
      employmentTo: this.employmentToControl = fb.control(''),
      workingHours: this.workingHoursControl = fb.control(''),
      currentLeave: this.currentLeaveControl = fb.control(''),
      dayToUse: this.dayToUseControl = fb.control(0),
      overdueLeave: this.overdueLeaveControl = fb.control(0),
      childcareLeaveToUse: this.childcareLeaveToUseControl = fb.control(0),
      receptionDayToUse: this.receptionDayToUseControl = fb.control(0),
    });
  }

  ngOnInit(): void {
    this.employee
      .pipe(takeUntil(this.destroyed$))
      .subscribe((employee: Employee) => {
        this.employeeObject = employee;
        this.initialize(employee);
      });

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    this.closeModification.emit();
  }

  sendForm(): void {
    this.formHelper.removeBackendErrorState(this.employeeForm, this.formErrors);
    this.formErrors = {};

    if (!this.employeeForm.valid) {
      this.employeeForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.employeeService.sendForm(this.employeeForm.getRawValue(), this.employeeObject.uuid)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Pomyślnie zaktualizowano obiekt pracownik', '', {
          duration: 2000,
        });
        this.closeModification.emit();
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji obiektu pracownik wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.employeeForm, this.formErrors);
          this.snack.open(error.error.error.text, error.status.toString(), {
            duration: 4000,
          });
        }
      })
    ;
  }

  initialize(employee: Employee): void {
    of(employee)
      .pipe(
        delay(0),
        tap(() => {
          if (employee && employee.leaveOfAbsence) {
            this.currentLeave = employee.leaveOfAbsence.find(
              x => x.year === new Date().getFullYear().toString()
            );
          }
          this.employeeForm.reset({
            employmentAt: employee.employmentAt,
            employmentTo: employee.employmentTo,
            workingHours: employee.workingHours?.id,
            currentLeave: this.currentLeave?.uuid,
            dayToUse: this.currentLeave?.dayToUse,
            overdueLeave:  this.currentLeave?.overdueLeave,
            childcareLeaveToUse:  this.currentLeave?.childcareLeaveToUse,
            receptionDayToUse:  this.currentLeave?.receptionDayToUse,
          });
        }),
        delay(0),
        tap(() => this.initialized$.next(true))
      ).subscribe();
  }

}
